<!-- 海宁：增加前手背书人输入框(必填)，去掉部门贴公司不贴等贴不贴的按钮以及是否复制的按钮 -->
<template>
  <div class="bankForm">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      @change="handleBlurChangeBaseData"
      @input="handleChangeBaseData"
      label-width="120px"
      :disabled="!canEdit"
    ></base-form>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  import { dateFormatter } from '@/common/js/util';
  import API from '@/api/capitalCenter/bill';
  import PAYMENT_API from '@/api/financeCenter/paymentApply.js';
  import DataBaseAPI from '@/api/dataBase';

  export default {
    name: 'bankForm',
    components: {
      baseForm,
    },
    props: [
      'sysConfigFlag',
      'type',
      'companyList',
      'canEdit',
      'marginPayAmount',
      'fundPaymentBillFlag',
    ],
    data() {
      return {
        baseData: {
          id: null,
          billSerialNumber: null,
          billCompanyCode: null,
          billCompanyName: null,
          billCode: null,
          billProperty: null,
          billCategory: null,
          billTakeDepartmentNo: null,
          billTakeDepartmentName: null,
          billAmount: null,
          currency: null,
          expiringDate: null,
          billMakerName: null,
          billMakeDate: null,
          billMakeBankNo: null,
          billMakeBankName: null,
          billMakeBankAccount: null,
          billStatus: null,
          claimStatus: null,
          billTakerNo: null,
          billTakerName: null,
          billTakeBankNo: null,
          billTakeBankName: null,
          billTakeBankAccount: null,
          billRecorderNo: null,
          billRecorderName: null,
          billRecordDate: null,
          billMark: null,
          isInterest: null,
          isRecourse: null,
          accountingStatus: 'notgenerate',
          arrivalBankAccount: null,
          arrivalBranchName: null,
          arrivalBranchCode: null,
          businessCategory: null,
          upperEndorseeNo: null,
          upperEndorseeName: null,
          serviceCharge: null,
          signIssueBankFullName: null,
        },
        collectData: {
          customerNo: null, // 客户编码
          customerName: null, // 客户名称
          customerType: null, // 客户类别
          arrivalBranchNo: null, // 入账银行
          arrivalBranchName: null, // 入账银行名称
          arrivalBankAccount: null, // 入账银行账号
          billSize: null, // 大小票
          paymentNature: null, // 款项性质
          billTakeDate: null,
          isCopy: null,
          isClaim: null, // 是否认领
          discountType: null,
          copyBillCode: null, // 原应收票据号
          copyBillTakeDepartmentName: null, // 原收票部门
          preEndorseeName: null, // 前手背书人(海宁)
        },
        payData: {
          billMakePledgeInfo: null,
          acceptorName: null,
          acceptBankNo: null,
          acceptBankName: null,
          acceptBankBranchNo: null,
          acceptBankAccount: null,
          contractNo: null,
          acceptDate: null,
          billMakerPromiseInfo: null,
          acceptorAcceptInfo: null,
          billAcceptPledgeInfo: null,
          isAssignment: null,
          isRefundDeposit: null,
          marginRate: null,
          marginAmount: null,
          cashflowCode: null, // 现金流量代码
          marginBankAccount: null, // 保证金银行
        },
        departmentList: [],
        partnersBanks: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      copyId() {
        return this.$route.query.copyId;
      },
      collectCanEditByStatus() {
        return this.fundPaymentBillFlag == '1'
          ? true
          : this.baseData.id && this.type == 'collect' && this.baseData.billStatus != '01';
      },
      //基础数据表单配置
      baseDataOptions() {
        return [
          {
            // 应收(应付)票据流水号
            type: 'input',
            label: this.$t(`billDetail.baseForm.${this.type}BillSerialNumber`),
            prop: 'billSerialNumber',
            placeholder: this.$t('billDetail.placeholder.auto'),
            disabled: true,
          },
          {
            // 公司代码
            type: 'select',
            label: this.$t('billDetail.baseForm.billCompanyCode'),
            prop: 'billCompanyCode',
            options: this.companyList,
            required: true,
            filterable: true,
            expandLabel: true,
            valueKey: 'value',
            disabled: this.collectCanEditByStatus,
          },
          // ...this.baseData.copyBillCode?[{ // 原应收票据号
          //   type: "input",
          //   label: this.$t(`billDetail.baseForm.copyBillCode`),
          //   prop: "copyBillCode",
          //   disabled: true
          // },
          // { // 原收票部门
          //   type: "input",
          //   label: this.$t(`billDetail.baseForm.copyBillTakeDepartmentNo`),
          //   prop: "copyBillTakeDepartmentName",
          //   disabled: true
          // }]:[],
          {
            // 应收(应付)票据号
            type: 'input',
            label: this.$t(`billDetail.baseForm.${this.type}BillCode`),
            prop: 'billCode',
            required: true,
            disabled: this.collectCanEditByStatus,
            maxlength: '32',
          },
          {
            // 票据性质
            type: 'dict',
            dictType: 'bill_property',
            label: this.$t('billDetail.baseForm.billProperty'),
            prop: 'billProperty',
            required: true,
            disabled: this.collectCanEditByStatus,
          },
          {
            // 票据类型
            type: 'dict',
            dictType: 'bill_category',
            label: this.$t('billDetail.baseForm.billCategory'),
            prop: 'billCategory',
            required: true,
            disabled: this.collectCanEditByStatus,
          },
          {
            // 收票(开票)部门
            type: 'select',
            label: this.$t(`billDetail.baseForm.${this.type}BillTakeDepartmentNo`),
            prop: 'billTakeDepartmentNo',
            valueKey: 'value',
            options: this.departmentList,
            required: true,
            filterable: true,
            disabled: this.collectCanEditByStatus,
          },
          {
            // 票据金额
            type: 'amountNumber',
            label: this.$t('billDetail.baseForm.billAmount'),
            prop: 'billAmount',
            required: true,
            max: 99999999999.99,
            min: 0,
            disabled: this.collectCanEditByStatus,
            maxlength: '20',
          },
          {
            // 币别
            type: 'dict',
            dictType: 'all_currency',
            label: this.$t('billDetail.baseForm.currency'),
            prop: 'currency',
            required: true,
            disabled: this.collectCanEditByStatus,
          },
          {
            // 到期日
            type: 'date',
            label: this.$t('billDetail.baseForm.expiringDate'),
            prop: 'expiringDate',
            required: true,
            disabled: this.collectCanEditByStatus,
          },
          ...(this.type == 'collect'
            ? [
                {
                  // 开票(出票)人
                  // type: 'searchTable',
                  // isMultiple: true,
                  label: this.$t(`billDetail.baseForm.${this.type}BillMakerName`),
                  // currentValue: this.baseData.billMakerName,
                  // searchType: 'customer',
                  prop: 'billMakerName',
                  // extraData: {
                  //   companyCode: this.baseData.billCompanyCode,
                  //   departmentCode: this.baseData.billTakeDepartmentNo,
                  // },
                  // getName: 'partnerZhName',
                  // placeholder: '请先选择公司和部门',
                  type: 'input',
                  required: true,
                  maxlength: '20',
                  disabled: this.collectCanEditByStatus,
                  // !this.baseData.billCompanyCode ||
                  // !this.baseData.billTakeDepartmentNo,
                },
              ]
            : [
                {
                  // 开票(出票)人
                  type: 'input',
                  label: this.$t(`billDetail.baseForm.${this.type}BillMakerName`),
                  prop: 'billMakerName',
                  required: true,
                  disabled: this.collectCanEditByStatus,
                  maxlength: '20',
                },
              ]),
          {
            // 开票(出票)日期
            type: 'date',
            label: this.$t(`billDetail.baseForm.${this.type}BillMakeDate`),
            prop: 'billMakeDate',
            required: true,
            disabled: this.collectCanEditByStatus,
          },
          ...(this.type == 'collect'
            ? [
                {
                  // 开票银行
                  // type: 'searchTable',
                  type: 'input',
                  prop: 'billMakeBankName',
                  // searchType: 'bankAccountBranchName',
                  // isMultiple: true,
                  label: this.$t(`billDetail.baseForm.collectBillMakeBankNo`),
                  required: true,
                  // name: 'billMakeBankName',
                  // getName: 'branchName',
                  // currentValue: this.baseData.billMakeBankName,
                  disabled: this.collectCanEditByStatus,
                },
                // {
                //   // 开票(出票)银行账号
                //   type: 'input',
                //   label: this.$t(`billDetail.baseForm.collectBillMakeBankAccount`),
                //   prop: 'billMakeBankAccount',
                //   disabled: true,
                // },
                // { // 客户
                //   type: "searchTable",
                //   prop: "customerNo",
                //   searchType: 'customer',
                //   isMultiple: true,
                //   label: this.$t("billDetail.baseForm.customerNo"),
                //   required: true,
                //   disabled:this.fundPaymentBillFlag=='1'?false:!this.canEdit,
                //   currentValue: this.baseData.customerName,
                //   extraData: {
                //     companyCode: this.baseData.billCompanyCode,
                //     departmentCode: this.baseData.billTakeDepartmentNo,
                //   }
                // }
              ]
            : [
                {
                  // 开票银行
                  type: 'searchTable',
                  prop: 'billMakeBankName',
                  searchType: 'bankAccountBranchName',
                  isMultiple: true,
                  label: this.$t('billDetail.baseForm.payBillMakeBankNo'),
                  required: true,
                  name: 'billMakeBankName',
                  getName: 'branchName',
                  currentValue: this.baseData.billMakeBankName,
                },
                {
                  type: 'input',
                  prop: 'billMakeBankAccount',
                  label: this.$t('billDetail.baseForm.payBillMakeBankAccount'),
                  placeholder: this.$t('billDetail.placeholder.auto'),
                  required: true,
                  disabled: true,
                },
              ]),
          {
            // 票据状态
            type: 'dict',
            dictType: `${this.type}_bill_status`,
            label: this.$t('billDetail.baseForm.billStatus'),
            prop: 'billStatus',
            placeholder: this.$t('billDetail.placeholder.auto'),
            disabled: true,
          },
          {
            // 认领状态
            type: 'dict',
            dictType: `bill_claim_status`,
            label: this.$t('billDetail.baseForm.claimStatus'),
            prop: 'claimStatus',
            placeholder: this.$t('billDetail.placeholder.auto'),
            disabled: true,
          },
          // { // 入账状态
          //   type: 'dict',
          //   dictType: "post_status" ,
          //   label: this.$t('billDetail.baseForm.accountingStatus'),
          //   prop: 'accountingStatus',
          //   placeholder: this.$t("billDetail.placeholder.auto"),
          //   disabled: true
          // },
          ...(this.type == 'collect'
            ? [
                // 应收
                {
                  // 收票人手动输入，选填
                  type: 'input',
                  label: this.$t(`billDetail.baseForm.${this.type}BillTakerName`),
                  prop: 'billTakerName',
                  disabled: this.collectCanEditByStatus,
                  maxlength: '20',
                  required: true,
                },
                {
                  // 收票日期，选填
                  type: 'date',
                  label: this.$t('billDetail.baseForm.billTakeDate'),
                  prop: 'billTakeDate',
                  disabled: this.collectCanEditByStatus,
                  required: true,
                },
                {
                  // 收票人银行，收票人银行取自银行主数据选填
                  type: 'searchTable',
                  prop: 'billTakeBankName',
                  searchType: 'bankAccountBranchName',
                  isMultiple: true,
                  label: this.$t(`billDetail.baseForm.${this.type}BillTakeBankNo`),
                  currentValue: this.baseData.billTakeBankName,
                  disabled: this.collectCanEditByStatus,
                  required: false,
                },
                {
                  // 收票人银行账号，收票人银行账号手动输入选填
                  type: 'input',
                  label: this.$t(`billDetail.baseForm.${this.type}BillTakeBankAccount`),
                  prop: 'billTakeBankAccount',
                  disabled: true,
                  required: false,
                },
                {
                  // 入账银行
                  type: 'searchTable',
                  prop: 'arrivalBranchName',
                  searchType: 'bankAccountBranchName',
                  isMultiple: true,
                  label: this.$t('billDetail.baseForm.arrivalBranchNo'),
                  currentValue: this.baseData.arrivalBranchName,
                  disabled: this.collectCanEditByStatus,
                  required: false,
                },
                {
                  // 入账银行账号
                  type: 'input',
                  label: this.$t('billDetail.baseForm.arrivalBankAccount'),
                  prop: 'arrivalBankAccount',
                  placeholder: this.$t('billDetail.placeholder.auto'),
                  disabled: true,
                  required: false,
                },
                // { // 大小票
                //   type: 'dict',
                //   dictType: "billSize" ,
                //   label: this.$t('billDetail.baseForm.billSize'),
                //   prop: 'billSize',
                //   disabled: this.collectCanEditByStatus
                // },
                // { // 款项性质
                //   type: 'dict',
                //   dictType: "paymentNature" ,
                //   label: this.$t('billDetail.baseForm.paymentNature'),
                //   prop: 'paymentNature',
                //   disabled: this.collectCanEditByStatus
                // }
              ]
            : [
                {
                  type: 'searchTable',
                  isMultiple: true,
                  label: this.$t(`billDetail.baseForm.${this.type}BillTakerName`),
                  currentValue: this.baseData.billTakerName,
                  searchType: 'supplier',
                  prop: 'billTakerName',
                  extraData: {
                    companyCode: this.baseData.billCompanyCode,
                    departmentCode: this.baseData.billTakeDepartmentNo,
                  },
                  getName: 'partnerZhName',
                  placeholder: '请先选择公司和收票部门',
                  required: true,
                  disabled: !this.baseData.billCompanyCode || !this.baseData.billTakeDepartmentNo,
                  maxlength: '20',
                },
                // {
                //   // 收票人银行，收票人银行取自银行主数据选填
                //   type: 'searchTable',
                //   prop: 'billTakeBankName',
                //   searchType: 'bankAccountBranchName',
                //   isMultiple: true,
                //   label: this.$t(`billDetail.baseForm.${this.type}BillTakeBankNo`),
                //   currentValue: this.baseData.billTakeBankName,
                //   disabled: this.collectCanEditByStatus,
                //   required: true,
                // },
                {
                  // 收款银行，收款银行取自供应商银行必填
                  type: 'select',
                  options: this.partnersBanks,
                  label: this.$t(`billDetail.baseForm.${this.type}BillTakeBankNo`),
                  prop: 'billTakeBankName',
                  currentValue: this.baseData.billTakeBankName,
                  isMultiple: true,
                  required: true,
                  disabled: this.collectCanEditByStatus,
                  filterable: true,
                },
                {
                  // 收款银行账号，收款银行账号由收款银行带出必填
                  type: 'input',
                  label: this.$t(`billDetail.baseForm.${this.type}BillTakeBankAccount`),
                  prop: 'billTakeBankAccount',
                  placeholder: this.$t('billDetail.placeholder.auto'),
                  disabled: true,
                  required: true,
                },
                /* {
                  // 保证金银行
                  type: 'searchTable',
                  prop: 'marginBankAccount',
                  searchType: 'bankAccount',
                  isMultiple: true,
                  label: this.$t('billDetail.baseForm.marginBankAccount'),
                  currentValue: this.baseData.marginBankAccount,
                  required: this.marginPayAmount && this.marginPayAmount != 0,
                  extraData: {
                    bankAccountStatus: '001',
                    secondaryClassCodes: ['ASC16'],
                  },
                }, */
                // {
                //   // 出票保证信息
                //   type: 'input',
                //   label: this.$t('billDetail.baseForm.billMakePledgeInfo'),
                //   prop: 'billMakePledgeInfo',
                //   span: 12,
                //   maxlength: '20',
                //   required: true,
                // },
                {
                  // 保证金比例
                  type: 'amountNumber',
                  label: this.$t('billDetail.baseForm.marginRate'),
                  prop: 'marginRate',
                  precision: this.$globalVar.iPoint,
                  maxlength: '20',
                  max: 99999999999999999999,
                  min: 0,
                },
                {
                  // 保证金金额
                  type: 'amountNumber',
                  label: this.$t('billDetail.baseForm.marginAmount'),
                  prop: 'marginAmount',
                  max: 99999999999.99,
                  min: 0,
                },
                {
                  // 手续费
                  type: 'amountNumber',
                  label: '手续费',
                  prop: 'serviceCharge',
                  max: 99999999999.99,
                  min: 0,
                },

                {
                  // 承兑人
                  type: 'input',
                  label: this.$t('billDetail.baseForm.acceptorName'),
                  prop: 'acceptorName',
                  required: false,
                  maxlength: '20',
                },
                //签发行全称
                {
                  type: 'input',
                  label: '签发行全称',
                  prop: 'signIssueBankFullName',
                  required: false,
                  maxlength: '32',
                },
                {
                  // 承兑银行
                  type: 'searchTable',
                  prop: 'acceptBankName',
                  searchType: 'bankAccountBranchName',
                  isMultiple: true,
                  label: this.$t('billDetail.baseForm.acceptBankNo'),
                  required: true,
                  name: 'acceptBankName',
                  getName: 'branchName',
                  currentValue: this.baseData.acceptBankName,
                },
                {
                  // 承兑银行行号
                  type: 'input',
                  label: this.$t('billDetail.baseForm.acceptBankBranchNo'),
                  prop: 'acceptBankBranchNo',
                  placeholder: this.$t('billDetail.placeholder.auto'),
                  required: true,
                  disabled: true,
                },
                {
                  // 承兑人银行账号
                  type: 'input',
                  label: this.$t('billDetail.baseForm.acceptBankAccount'),
                  prop: 'acceptBankAccount',
                  placeholder: this.$t('billDetail.placeholder.auto'),
                  required: true,
                  disabled: true,
                },
                {
                  // 承兑日期
                  type: 'date',
                  label: this.$t('billDetail.baseForm.acceptDate'),
                  prop: 'acceptDate',
                  required: true,
                },
                {
                  // 交易合同号
                  type: 'input',
                  label: this.$t('billDetail.baseForm.contractNo'),
                  prop: 'contractNo',
                  maxlength: '20',
                },
                {
                  // 出票人承诺信息
                  type: 'input',
                  label: this.$t('billDetail.baseForm.billMakerPromiseInfo'),
                  prop: 'billMakerPromiseInfo',
                  span: 20,
                  maxlength: '256',
                },
                {
                  // 承兑人承兑信息
                  type: 'input',
                  label: this.$t('billDetail.baseForm.acceptorAcceptInfo'),
                  prop: 'acceptorAcceptInfo',
                  span: 20,
                  maxlength: '256',
                },
                {
                  // 承兑保证信息
                  type: 'input',
                  label: this.$t('billDetail.baseForm.billAcceptPledgeInfo'),
                  prop: 'billAcceptPledgeInfo',
                  maxlength: '256',
                  span: 20,
                },
                /* {
                  // 现金流量代码
                  type: 'searchTable',
                  label: this.$t('billDetail.baseForm.cashflowCode'),
                  prop: 'cashflowCode',
                  searchType: 'cashflow',
                  isMultiple: true,
                  currentValue: this.baseData.cashflowCode,
                }, */
              ]),
          {
            // 录入人
            type: 'input',
            label: this.$t('billDetail.baseForm.billRecorderName'),
            prop: 'billRecorderName',
            maxlength: '20',
            required: true,
          },
          {
            // 录入日期
            type: 'date',
            label: this.$t('billDetail.baseForm.billRecordDate'),
            prop: 'billRecordDate',
            required: true,
          },
          ...(this.type == 'collect'
            ? [
                {
                  type: 'select',
                  label: '业务类别',
                  prop: 'businessCategory',
                  required: true,
                  disabled: this.collectCanEditByStatus,
                  valueKey: 'value',
                  options: [
                    {
                      value: '01',
                      label: '贸易',
                    },
                    {
                      value: '02',
                      label: '多式联运',
                    },
                  ],
                },
              ]
            : []),
          ...(this.type == 'collect'
            ? [
                {
                  type: 'searchTable',
                  isMultiple: true,
                  label: '上手背书人',
                  currentValue: this.baseData.upperEndorseeName,
                  searchType: 'partnerCollectBill',
                  prop: 'upperEndorseeName',
                  extraData: {
                    companyCode: this.baseData.billCompanyCode,
                    departmentCode: this.baseData.billTakeDepartmentNo,
                    partnerTypes: 'HZHB01',
                  },
                  getName: 'partnerZhName',
                  placeholder: '请选择',
                  required: true,
                  disabled: this.collectCanEditByStatus,
                  maxlength: '20',
                },
              ]
            : []),
          {
            // 备注
            type: 'input',
            label: this.$t('billDetail.baseForm.billMark'),
            prop: 'billMark',
            span: 20,
            maxlength: '256',
            disabled: this.collectCanEditByStatus,
          },
          // ...this.type=='collect'?[...this.sysConfigFlag=='Y'?[]:[{ // 是否复制
          //   type: "checkbox",
          //   text: this.$t("billDetail.baseForm.isCopy"),
          //   prop: "isCopy",
          //   disabled: true,
          // }],{ // 是否认领
          //   type: "checkbox",
          //   text: this.$t("billDetail.baseForm.isClaim"),
          //   prop: "isClaim",
          // }]:[],
          // { // 是否计息
          //   type: "checkbox",
          //   text: this.$t("billDetail.baseForm.isInterest"),
          //   prop: "isInterest",
          // },
          // { // 是否带追索权
          //   type: "checkbox",
          //   text: this.$t("billDetail.baseForm.isRecourse"),
          //   prop: "isRecourse",
          // },
          // ...(this.type == 'pay'
          //   ? [
          //       /*  {
          //         // 能否转让
          //         type: 'checkbox',
          //         text: this.$t('billDetail.baseForm.isAssignment'),
          //         prop: 'isAssignment',
          //       },
          //       {
          //         // 已退回保证金
          //         type: 'checkbox',
          //         text: this.$t('billDetail.baseForm.isRefundDeposit'),
          //         prop: 'isRefundDeposit',
          //         disabled: true,
          //       }, */
          //     ]
          //   : []),
          // ...this.type=='collect'&&!this.baseData.isCopy&&this.sysConfigFlag!='Y'?[
          //   {  // 贴现类型
          //     type: 'dict',
          //     dictType: "discount_type" ,
          //     label: this.$t('billDetail.baseForm.discountType'),
          //     prop: 'discountType',
          //   }
          // ]:[],
        ];
      },
    },
    created() {
      this.baseData = {
        ...this.baseData,
        ...this[`${this.type}Data`],
      };
      if (this.$route.name.indexOf('Add') != -1 && !this.copyId) {
        this.baseData.currency = 'CNY';
        this.baseData.billRecorderNo = Number(this.userInfo.userCode);
        this.baseData.billRecorderName = this.userInfo.userName;
        this.baseData.billRecordDate = dateFormatter(new Date());
      }
    },
    methods: {
      async getPartnerInfo(partnerCode) {
        var { data } = await this.$axios.post('/maindata/partners/getPartnerInfoByCode', {
          partnerCode,
        });
        if (data.code == 0 && data.data) {
          return data.data;
        } else {
          // this.$message({ showClose: true, message: data.msg, type: 'error' });
        }
        return {};
      },
      async _assignAdditionalInfo(partnerCode, isMaker = true) {
        let additionalInfo = await this.getPartnerInfo(partnerCode);
        if (!additionalInfo) {
          return;
        }

        let bankLines = additionalInfo.partnersBanks;

        if (bankLines && bankLines.length) {
          let info = bankLines[0];
          if (isMaker) {
            this.baseData.billMakeBankName = info?.bankName;
            this.baseData.billMakeBankAccount = info?.bankAccount;
          } else {
            this.baseData.billTakeBankName = info?.bankName;
            this.baseData.billTakeBankAccount = info?.bankAccount;
          }
        }
        this.getBankInfo(partnerCode, this.baseData.billCompanyCode);
      },
      handleChangeBaseData(value, prop) {
        //基本数据表单变化
        if (prop == 'billCompanyCode') {
          // 公司
          this.companyChange(value.billCompanyCode);
        } else if (prop == 'billMakerName') {
          if (this.type == 'collect') {
            // console.log('billMakerName', value, prop);
            let model = value?.billMakerName[0];
            if (model && model?.partnerZhName) {
              this.baseData.billMakerName = model?.partnerZhName;
              this._assignAdditionalInfo(model?.partnerCode);
            }
          }
        } else if (prop == 'upperEndorseeName') {
          let model = value?.upperEndorseeName[0];
          if (model) {
            this.baseData.upperEndorseeName = model.partnerZhName;
            this.baseData.upperEndorseeNo = model.partnerCode;
          }
        } else if (prop == 'billTakerName') {
          let model = value?.billTakerName[0];
          if (model && model?.partnerZhName) {
            this.baseData.billTakerName = model?.partnerZhName;
            this._assignAdditionalInfo(model?.partnerCode, false);
          }
        } else if (prop == 'billMakeBankName') {
          // 开票(出票)银行
          if (this.type == 'pay') {
            this.searchTableChange(value.billMakeBankName, [
              { val: 'billMakeBankName', getVal: 'branchName' },
              { val: 'billMakeBankNo', getVal: 'branchCode' },
              { val: 'acceptBankName', getVal: 'branchName' },
              { val: 'billMakeBankAccount', getVal: 'bankAccountNum' },
              { val: 'acceptBankNo', getVal: 'branchCode' },
              { val: 'acceptBankBranchNo', getVal: 'branchCode' },
              { val: 'acceptBankAccount', getVal: 'bankAccountNum' },
            ]);
          } else {
            // this.searchTableChange(value.billMakeBankName, [
            //   { val: 'billMakeBankName', getVal: 'branchName' },
            //   { val: 'billMakeBankNo', getVal: 'branchCode' },
            //   { val: 'billMakeBankAccount', getVal: 'bankAccountNum' },
            // ]);
          }
        } else if (prop == 'billTakeDepartmentNo') {
          // 收票(开票)部门
          this.departmentChange(value.billTakeDepartmentNo);
        } else if (prop == 'billTakeBankName') {
          // 收票人
          if (this.type == 'collect') {
            this.searchTableChange(value.billTakeBankName, [
              { val: 'billTakeBankName', getVal: 'branchName' },
              { val: 'billTakeBankNo', getVal: 'branchCode' },
              { val: 'billTakeBankAccount', getVal: 'bankAccountNum' },
            ]);
          } else {
            this.baseData.billTakeBankNo = this.partnersBanks?.find(
              (item) => item.value == value.billTakeBankName
            );
            const tempData = this.partnersBanks?.find(
              (item) => item.value == value.billTakeBankName
            );
            if (tempData) {
              this.baseData.billTakeBankNo = tempData?.associatedLineNumber;
              this.baseData.billTakeBankName = tempData?.accountBankBranch;
              this.baseData.billTakeBankAccount = tempData?.bankAccount;
            }
          }
        } else if (prop == 'acceptBankName') {
          // 承兑银行
          this.searchTableChange(value.acceptBankName, [
            { val: 'acceptBankName', getVal: 'branchName' },
            { val: 'acceptBankNo', getVal: 'branchCode' },
            { val: 'acceptBankBranchNo', getVal: 'branchCode' },
            { val: 'acceptBankAccount', getVal: 'bankUnionNumber' },
          ]);
          this.$refs.baseData.$refs.ruleForm.clearValidate([
            'acceptBankBranchNo',
            'acceptBankAccount',
          ]);
        } else if (prop == 'arrivalBranchName') {
          // 入账银行
          this.searchTableChange(value.arrivalBranchName, [
            { val: 'arrivalBranchName', getVal: 'branchName' },
            { val: 'arrivalBranchNo', getVal: 'branchCode' },
            { val: 'arrivalBranchCode', getVal: 'branchCode' },
            { val: 'arrivalBankAccount', getVal: 'bankAccountNum' },
          ]);
        } else if (prop == 'customerNo') {
          this.searchTableChange(value.customerNo, [
            { val: 'customerNo', getVal: 'partnerCode' },
            { val: 'customerName', getVal: 'partnerZhName' },
            { val: 'customerType', getVal: 'partnerType' },
          ]);
          let obj = {
            customerNo: value.customerNo,
            customerName: value.customerName,
            customerType: value.customerType,
          };
          this.$emit('customerChange', obj);
        }
        if (this.type == 'pay') {
          if (prop == 'billTakerName') {
            // 收款人
            /*  this.searchTableChange(value.billTakerName, [
              { val: 'billTakerName', getVal: 'partnerZhName' },
              { val: 'billTakerNo', getVal: 'partnerCode' },
            ]);
            this.partnersBanks = [];
            this.baseData.billTakeBankNo =
              this.baseData.billTakeBankName =
              this.baseData.billTakeBankAccount =
                '';
            // this.getBankInfo(this.baseData.billTakerNo, this.baseData.billCompanyCode); */
          } /* else if (prop == 'billTakeBankName') {
            // 收款银行
            this.searchTableChange(value.billTakeBankName, [
              { val: 'billTakeBankName', getVal: 'branchName' },
              { val: 'billTakeBankNo', getVal: 'branchCode' },
              { val: 'billTakeBankAccount', getVal: 'bankAccountNum' },
            ]);
            //this.billTakeBankChange(value.billTakeBankAccount);
          } */ else if (prop == 'expiringDate') {
            // 到期日
            this.dateCompare(prop);
            this.$emit('expiringDateChange', value.expiringDate);
          } else if (prop == 'billMakeBankAccount') {
            // 出票银行账号
            this.$emit('billMakeBankAccountChange', value.billMakeBankAccount);
            this.searchTableChange(value.billMakeBankAccount, [
              { val: 'billMakeBankAccount', getVal: 'bankAccountNum' },
            ]);
          } else if (prop == 'cashflowCode') {
            // 现金流量代码
            this.searchTableChange(value.cashflowCode, [{ val: 'cashflowCode' }]);
          } else if (prop == 'marginBankAccount') {
            // 保证金银行
            this.searchTableChange(value.marginBankAccount, [
              { val: 'marginBankAccount', getVal: 'bankAccountNum' },
            ]);
            this.$emit('marginBankAccountChange');
          } else if (prop == 'marginAmount') {
            //保证金金额
            if (
              this.baseData.marginAmount &&
              this.baseData.marginAmount !== 0 &&
              !this.baseData.cashflowCode
            ) {
              this.baseData.cashflowCode = '999999';
            }
            //this.$emit('marginBankAccountChange',"marginAmount");
          } else if (prop == 'billAmount') {
            //票据金额
            if (this.baseData.marginRate && this.baseData.marginRate !== 0) {
              this.baseData.marginAmount = this.$cal.calCommon(
                this.baseData.billAmount,
                this.baseData.marginRate,
                '*',
                'amount'
              );
              //this.$emit('marginBankAccountChange',"marginAmount");
            }
          } else if (prop == 'marginRate') {
            //保证金比例
            if (this.baseData.billAmount && this.baseData.billAmount !== 0) {
              this.baseData.marginAmount = this.$cal.calCommon(
                this.baseData.billAmount,
                this.baseData.marginRate,
                '*',
                'amount'
              );
              //this.$emit('marginBankAccountChange',"marginAmount");
            }
          } else if (prop == 'billMakeDate' || prop == 'acceptDate' || prop == 'billRecordDate') {
            this.dateCompare(prop);
          }
        }
        this.$emit('basicInfoChange', this.baseData);
      },
      handleBlurChangeBaseData(value, prop) {
        if (prop == 'billCode' && value.billCode) {
          // 应收票据号
          this.checkBillCodeUsed(value.billCode);
        }
      },
      dateCompare(prop) {
        /* 到期日:大于出票日，承兑日，录入日
          出票日期：小于到期日
          承兑日期：在出票，到期之间
          录入日期：在出票，到期之间 */
        let expiringDate = this.baseData.expiringDate;
        let billMakeDate = this.baseData.billMakeDate;
        let acceptDate = this.baseData.acceptDate;
        let billRecordDate = this.baseData.billRecordDate;
        let flag = expiringDate && billMakeDate && acceptDate && billRecordDate;
        if (
          flag &&
          !(
            expiringDate > billMakeDate &&
            expiringDate > acceptDate &&
            expiringDate > billRecordDate
          )
        ) {
          this.baseData[prop] = null;
          return this.$message({
            showClose: true,
            type: 'error',
            message: '到期日期必须大于出票日期，承兑日期，录入日期',
          });
        }
        if (flag && !(expiringDate >= acceptDate && acceptDate >= billMakeDate)) {
          this.baseData[prop] = null;
          return this.$message({
            showClose: true,
            type: 'error',
            message: '承兑日期必须在出票日期和到期日期之间',
          });
        }
        if (flag && !(expiringDate >= billRecordDate && billRecordDate >= billMakeDate)) {
          this.baseData[prop] = null;
          return this.$message({
            showClose: true,
            type: 'error',
            message: '录入日期必须在出票日期和到期日期之间',
          });
        }
      },
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
            this.$emit('getDepartment', this.departmentList);
          }
        } else {
          this.departmentList = [];
          this.$emit('getDepartment', []);
        }
      },
      async checkBillCodeUsed(val) {
        // 校验票据号是否重复
        let res = await this.$axios.get(API.CHECK_BILLCODEUSED, {
          billCode: val,
          id: this.$route.query.id,
          billType: this.type == 'pay' ? '2' : '1',
        });
        if (res) {
          if (res.data.code == 0) {
            if (res.data.data) {
              this.$message({
                showClose: true,
                type: 'error',
                message: this.$t('billDetail.message.billCodeUsed'),
              });
              this.baseData.billCode = null;
            }
          }
        }
      },
      async getBankInfo(partnerCode) {
        // 获取收票(收款)人对应银行
        if (partnerCode) {
          let res = await this.$axios.get(PAYMENT_API.GET_PARTER_BANK, {
            partnerCode,
            // companyCode,
          });
          if (res) {
            if (res.data.code == 0) {
              console.log(res.data.data);
              this.partnersBanks = res.data.data.map((item) => {
                return {
                  ...item,
                  value: item.bankAccount,
                  label: item.bankName + '-' + item.bankAccount,
                };
              });
              if (res.data.data && res.data.data.length) {
                let tempData = res.data.data[0];
                this.baseData.billTakeBankNo = tempData.associatedLineNumber;
                this.baseData.billTakeBankName = tempData.accountBankBranch;
                this.baseData.billTakeBankAccount = tempData.bankAccount;
              } else if (!res.data.data || res.data.data.length == 0) {
                this.baseData.billTakeBankNo = null;
                this.baseData.billTakeBankName = null;
                this.baseData.billTakeBankAccount = null;
              }
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          }
        }
      },
      companyChange(val) {
        if (this.type == 'collect') {
          this.baseData.billMakerName = null;
        }
        this.baseData.billTakerName = null;
        this.baseData.customerNo = this.baseData.customerName = this.baseData.customerType = '';
        this.baseData.billCompanyName = val
          ? this.companyList.find((item) => item.value == val).label
          : '';
        this.baseData.billTakeDepartmentName = this.baseData.billTakeDepartmentNo = '';
        if (this.type == 'pay') {
          [
            'billTakerName',
            'billTakerNo',
            'billTakeBankNo',
            'billTakeBankName',
            'billTakeBankAccount',
          ].map((item) => {
            return (this.baseData[item] = '');
          });
          this.partnersBanks = [];
        }
        this.getDepartment(val);
        this.$emit('getSysConfigByCompany', val);
      },
      departmentChange(val) {
        if (this.type == 'collect') {
          this.baseData.billMakerName = null;
        }
        this.baseData.billTakerName = null;
        this.baseData.customerNo = this.baseData.customerName = this.baseData.customerType = '';
        this.baseData.billTakeDepartmentName = val
          ? this.departmentList.find((item) => item.value == val).label
          : '';
        if (this.type == 'pay') {
          [
            'billTakerName',
            'billTakerNo',
            'billTakeBankNo',
            'billTakeBankName',
            'billTakeBankAccount',
          ].map((item) => {
            return (this.baseData[item] = '');
          });
          this.partnersBanks = [];
        }
        let obj = {
          departmentName: this.baseData.billTakeDepartmentName,
          departmentNo: this.baseData.billTakeDepartmentNo,
        };
        this.$emit('departmentChange', obj);
      },
      billTakeBankChange(val) {
        if (val) {
          let item = this.partnersBanks.find((i) => i.value == val);
          this.baseData.billTakeBankNo = item.associatedLineNumber;
          this.baseData.billTakeBankName = item.accountBankBranch;
        } else {
          this.baseData.billTakeBankNo = this.baseData.billTakeBankName = '';
        }
        console.log(this.baseData.billTakeBankName);
      },
      searchTableChange(val, fooArr) {
        if (val && val.length > 0) {
          fooArr.map((item) => {
            if (item.getVal) {
              this.baseData[item.val] = val[0][item.getVal];
            } else {
              this.baseData[item.val] = val[0][item.val];
            }
          });
        } else {
          fooArr.map((item) => {
            this.baseData[item.val] = null;
          });
        }
      },
      // 返回数据
      exportChildData() {
        // 点击提交，走校验
        let sign = false;
        let baseData = { ...this.baseData };
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
            Object.keys(baseData).map((item) => {
              if (item.indexOf('is') == 0) {
                return (baseData[item] = baseData[item] ? '1' : '0');
              }
            });
          } else {
            sign = false;
          }
        });
        return sign ? baseData : false;
      },
    },
  };
</script>
